import { memo, useEffect } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export const CourseOverviewPageSkeleton = memo(function CourseOverviewPageSkeleton() {
  // Set performance mark when skeleton mounts so content can measure render duration
  useEffect(() => {
    performance.mark('CourseOverview:RenderStart');
  }, []);

  return (
    <div className="flex flex-col h-full bg-background">
      {/* Top bar skeleton */}
      <div className="h-12 w-full border-b border-border/40 flex items-center gap-3 px-4 shadow-sm">
        <Skeleton className="h-8 w-8 rounded-md" />
        <Skeleton className="h-5 w-40 rounded-md" />
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        <div className="max-w-5xl mx-auto px-6 py-8">
          {/* Hero — two-column */}
          <div className="grid grid-cols-1 xl:grid-cols-5 gap-8 mb-10">
            {/* Left column */}
            <div className="xl:col-span-3 space-y-4 order-2 xl:order-1">
              <Skeleton className="h-9 w-72 rounded-md" />
              <Skeleton className="h-4 w-full max-w-lg rounded-md" />
              <Skeleton className="h-4 w-full max-w-md rounded-md" />
              <div className="flex gap-4 pt-1">
                <Skeleton className="h-4 w-24 rounded-md" />
                <Skeleton className="h-4 w-20 rounded-md" />
                <Skeleton className="h-4 w-16 rounded-md" />
              </div>
              <div className="flex gap-2 pt-1">
                <Skeleton className="h-6 w-20 rounded-full" />
                <Skeleton className="h-6 w-16 rounded-full" />
                <Skeleton className="h-6 w-24 rounded-full" />
              </div>
              <div className="space-y-1.5 max-w-md pt-1">
                <Skeleton className="h-4 w-28 rounded-md" />
                <Skeleton className="h-3 w-full rounded-full" />
              </div>
              <Skeleton className="h-11 w-40 rounded-md mt-2" />
            </div>

            {/* Right column — cover image */}
            <div className="xl:col-span-2 order-1 xl:order-2">
              <Skeleton className="w-full aspect-[4/3] rounded-2xl" />
            </div>
          </div>

          {/* Chapter list skeleton */}
          <Skeleton className="h-5 w-24 rounded-md mb-4" />
          <div className="space-y-3">
            {[0, 1].map((i) => (
              <div key={i} className="bg-card rounded-xl border border-border overflow-hidden">
                <div className="flex items-center justify-between px-4 py-3.5">
                  <div className="flex items-center gap-3">
                    <Skeleton className="h-4.5 w-4.5 rounded-full" />
                    <Skeleton className="h-5 w-48 rounded-md" />
                  </div>
                  <Skeleton className="h-4 w-24 rounded-md" />
                </div>
                {i === 0 &&
                  [0, 1, 2].map((j) => (
                    <div key={j} className="flex items-center gap-2.5 px-6 py-2.5">
                      <Skeleton className="h-4 w-4 rounded-full" />
                      <Skeleton className="h-4 flex-1 rounded-md" />
                      <Skeleton className="h-3 w-10 rounded-md" />
                    </div>
                  ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});
